<template>
  <el-dialog
    title="修改告警状态"
    :visible.sync="dialogFormVisible"
    width="550px"
    :before-close="close"
  >
    <el-form ref="form" :model="initForm">
      <el-form-item label="告警状态" label-width="120px">
        <el-select v-model="initForm.alarm_status" @change="changeStatus">
          <el-option
            v-for="alarm_status in alarmstatusList"
            :label="alarm_status.Name"
            :key="alarm_status.ID"
            :value="alarm_status.ID"
          >
          </el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="$emit('close')">取 消</el-button>
      <el-button type="primary" @click="submit">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { Alarmstatus, alarmstatusList } from "@/components/Index/data.js";
export default {
  props: {
    initForm: {}
  },
  data() {
    return {
      dialogFormVisible: true,
      Alarmstatus: Alarmstatus,
      alarmstatusList: alarmstatusList,
      value: ""
    };
  },
  mounted() {
    this.initForm.alarm_status = this.initForm.alarm_status.toString();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    submit() {
      this.$refs.form.validate(valid => {
        if (!valid) return false;
        let methods = "patch";
        let url = "device_alarms/" + this.initForm.id + "/";
        this.$http[methods](
          url,
          {
            alarm_status: this.initForm.alarm_status,
            end_time: this.initForm.end_time,
            confirm_user: localStorage.getItem("username")
          },
          () => {
            this.$baseNotice.message("编辑成功");
            this.$emit("close");
            this.$emit("update");
          }
        );
      });
    },
    changeStatus() {
      //状态设置为已解决，赋予解决时间
      if (this.initForm.alarm_status === "2") {
        var time = new Date();
        var nowYear = time.getFullYear().toString();
        var nowMonth = (time.getMonth() + 1).toString();
        var nowDay = time.getDate().toString();
        var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
        var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
        var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

        nowYear = this.timeAdd0(nowYear);
        nowMonth = this.timeAdd0(nowMonth);
        nowDay = this.timeAdd0(nowDay);
        nowHours = this.timeAdd0(nowHours);
        nowMin = this.timeAdd0(nowMin);
        nowSeconds = this.timeAdd0(nowSeconds);
        this.initForm.end_time =
          nowYear +
          "-" +
          nowMonth +
          "-" +
          nowDay +
          " " +
          nowHours +
          ":" +
          nowMin +
          ":" +
          nowSeconds;
      } else {
        this.initForm.end_time = null;
      }
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  }
};
</script>
